import LoggedUserIndicator from "@molecules/logged-user-indicator/logged-user-indicator";

// ─── Class ────────────────────────────────────────────────────────────────────

export class MainNavigation {
  private el: HTMLElement;

  constructor(el: HTMLElement) {
    this.el = el;
  }

  init(): void {
    LoggedUserIndicator.updateLoginIndicator(this.el);
  }

  destroy(): void {}

  // ─── Static bootstrap ───────────────────────────────────────────────────────

  static initAll(root: Document | HTMLElement = document): void {
    root
      .querySelectorAll<HTMLElement>('[data-component="main-navigation"]')
      .forEach((el) => {
        new MainNavigation(el).init();
      });
  }
}
